import React from 'react'
import { DateObject } from 'react-multi-date-picker'
import AppDatePicker from './AppDatePicker'
import Toolbar from 'react-multi-date-picker/plugins/toolbar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { CalendarIcon, CaretDownIcon } from '@phosphor-icons/react'
import dayjs from '../utils/dayjsConfig'

const DateRangeFilter = ({
  disabled,
  value,
  onChange,
  inputTitle = 'Rango de fechas',
  placeholder = '',
  variant = 'default'
}) => {
  const isModern = variant === 'modern'
  const isFilter = variant === 'filter'
  const displayFormat =
    value?.length > 1 && value[0].year() !== value[value.length - 1].year()
      ? 'DD MMM YYYY'
      : 'DD MMM'
  // Un rango de un día conserva una sola fecha seleccionada para ampliarlo con el siguiente clic.
  const pickerDates =
    isFilter && value?.length === 2 && value[0].isSame(value[1], 'day') ? [value[0]] : value
  const pickerValue = Array.isArray(pickerDates)
    ? pickerDates.map((d) => new DateObject(d.toDate()))
    : null

  const handleChange = (dates) => {
    if (!dates?.length) {
      onChange(null)
      return
    }

    onChange(dates.map((d) => dayjs(d.toDate())))
  }

  return (
    <AppDatePicker
      className={isModern || isFilter ? 'report-period-calendar' : undefined}
      containerClassName={
        isFilter
          ? 'filter-ubiqua-mui-filter-control is-date-range'
          : isModern
            ? 'report-period-picker'
            : undefined
      }
      portal={isFilter}
      zIndex={isFilter ? 1300 : undefined}
      calendarPosition={isFilter ? 'bottom-end' : undefined}
      disabled={disabled}
      range
      dateSeparator=" - "
      format="DD MMM"
      maxDate={dayjs().local().endOf('day').toDate()}
      value={pickerValue}
      onChange={handleChange}
      plugins={[<Toolbar position="bottom" sort={[]} />]}
      render={(_, openCalendar) =>
        isFilter ? (
          <button
            type="button"
            className={`filter-ubiqua-mui-filter-trigger${value?.length ? ' has-value' : ''}`}
            disabled={disabled}
            onClick={openCalendar}
            aria-label={`${inputTitle}: ${value?.map((d) => d.format('DD MMM YYYY')).join(' - ') || 'Seleccionar fechas'}`}
            aria-haspopup="dialog"
            title={
              value?.length ? value.map((d) => d.format('DD MMM YYYY')).join(' - ') : inputTitle
            }
          >
            <CalendarIcon size={16} aria-hidden="true" />
            <span className="filter-ubiqua-mui-filter-value">
              {value?.length
                ? value.map((d) => d.format(displayFormat)).join(' – ')
                : placeholder || 'Rango de fechas'}
            </span>
            <CaretDownIcon
              className="filter-ubiqua-mui-filter-chevron"
              size={14}
              weight="bold"
              aria-hidden="true"
            />
          </button>
        ) : isModern ? (
          <button
            type="button"
            className="report-period-trigger"
            disabled={disabled}
            onClick={openCalendar}
            aria-label={`Periodo de búsqueda: ${value?.map((d) => d.format('DD MMM YYYY')).join(' - ') || 'Seleccionar fechas'}`}
            aria-haspopup="dialog"
          >
            <span className="report-period-icon" aria-hidden="true">
              <CalendarIcon size={18} />
            </span>
            <span className="report-period-value">
              {value?.length ? (
                <>
                  <span className="report-period-label">Desde</span>{' '}
                  {value[0].format(displayFormat)}
                  <span className="report-period-divider"> – </span>
                  <span className="report-period-label">Hasta</span>{' '}
                  {value[1]?.format(displayFormat) || 'Seleccionar'}
                </>
              ) : (
                'Seleccionar fechas'
              )}
            </span>
            <span className="report-period-chevron" aria-hidden="true">
              <CaretDownIcon size={14} weight="bold" />
            </span>
          </button>
        ) : (
          <div
            className={`mr-10 date-range-filter ${disabled ? 'react-filter-disabled date-range-filter--disabled' : ''}`}
          >
            <div
              className="react-filter-box filter-input-width-datepicker"
              style={{ marginTop: 0 }}
            >
              <div
                title={inputTitle || undefined}
                onClick={!disabled ? openCalendar : undefined}
                className="react-filter-box-clickable-zone"
              >
                <div className="react-filter-titles">
                  {Array.isArray(value) && value.length > 0 ? (
                    <div className="filter-title-overflow">
                      {value.map((d) => d.format('DD MMM')).join(' - ')}
                    </div>
                  ) : (
                    placeholder && <div className="filter-title-overflow">{placeholder}</div>
                  )}

                  <FontAwesomeIcon
                    icon={faCalendar}
                    style={{ color: disabled ? '#a0a0a0' : '#597fa9' }}
                  />
                </div>
              </div>
            </div>
          </div>
        )
      }
    />
  )
}

export default DateRangeFilter
